import { CalendarDay } from '../../../utils';
import { z } from 'zod';

type RealisationFormData = {
  holdingClassRealisation: Array<{
    unitsAllocationPerInvestment?: Array<{
      totalInvestmentAmountLcy?: number | null;
      allocatedUnits: number;
      date: Date;
    }>;
  }>;
};

const validateInvestmentsHaveLcyValues = (
  data: RealisationFormData,
  ctx: z.RefinementCtx,
) => {
  const invalidInvestments = data.holdingClassRealisation
    .flatMap((holdingClass) => holdingClass.unitsAllocationPerInvestment ?? [])
    .filter(
      (investment) =>
        (investment.totalInvestmentAmountLcy === null ||
          investment.totalInvestmentAmountLcy === undefined) &&
        investment.allocatedUnits !== 0,
    );

  if (invalidInvestments.length > 0) {
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      path: [],
      message: `Please reconcile the initial investment(s) (${invalidInvestments
        .map((inv) => new CalendarDay(inv.date).toLabel())
        .join(', ')}) transaction(s) before processing a realisation.`,
    });
  }
};

export default validateInvestmentsHaveLcyValues;
